import {MeterType, meterTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<MeterType>;

export const MeterTypeSelect = (props: Props) => {
  const {options = meterTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
